import { render, staticRenderFns } from "./ComponentTree.vue?vue&type=template&id=467fb939"
import script from "./ComponentTree.vue?vue&type=script&lang=js"
export * from "./ComponentTree.vue?vue&type=script&lang=js"
import style0 from "./ComponentTree.vue?vue&type=style&index=0&id=467fb939&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports